import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIContractClientDtoResponse, ContractClientDto } from '../types/api'
import { CLIENT_CONTRACTS_ID_PATH, CLIENT_CONTRACTS_PATH } from '../types/constants'
import { ContractType } from '../types/general'

export interface ClientGetServiceAgreementOptions {
  hasSharedCRM: boolean
}

export const ClientContractsService = {
  getServiceAgreement: (
    locationId: string,
    { hasSharedCRM }: ClientGetServiceAgreementOptions
  ): Promise<ContractClientDto | null> => {
    return requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: { type: ContractType.ServiceAgreement, includeShared: !!hasSharedCRM },
    }).then((res) => res?.results?.[0] ?? null)
  },

  listServiceAgreements: (
    locationId: string,
    { hasSharedCRM }: ClientGetServiceAgreementOptions
  ): Promise<APIContractClientDtoResponse | null> => {
    return requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: { type: ContractType.ServiceAgreement, includeShared: !!hasSharedCRM },
    })
  },

  getContract: (locationId: string, id: string): Promise<ContractClientDto | null> => {
    return requestGooseAPI<ContractClientDto>({
      url: getAPIPath(CLIENT_CONTRACTS_ID_PATH, { locationId, id }),
      method: 'GET',
    })
  },
}
